import React, { useEffect, useState } from 'react';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import { Folder as FolderIcon, ExpandMore, ChevronRight } from '@mui/icons-material';
import api from '../api';
import { FileMetadata } from '../types';

const FolderTree = () => {
    const [folders, setFolders] = useState<FileMetadata[]>([]);

    useEffect(() => {
        const fetchFolders = async () => {
            try {
                const files = await api.listFiles('./fm.glow-in-the-dark.eu', '', 1, 50, false);
                setFolders(files);
            } catch (error) {
                console.error('Error fetching folders:', error);
            }
        };

        fetchFolders();
    }, []);

    const renderTree = (nodes: any) => (
        <TreeItem key={nodes.name} nodeId={nodes.name} label={nodes.name} icon={<FolderIcon />}>
            {Array.isArray(nodes.children) ? nodes.children.map(renderTree) : null}
        </TreeItem>
    );

    return (
        <TreeView
            defaultCollapseIcon={<ExpandMore />}
            defaultExpandIcon={<ChevronRight />}
        >
            {Array.isArray(folders) ? folders.map(renderTree) : null}
        </TreeView>
    );
};

export default FolderTree;